export default __webpack_public_path__ + "static/media/BASSETS-2.ff5ccdf7.png";